import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject
} from '@angular/core';

import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {ApiService} from "../../../../services/api/api.service";
import {HttpParams} from "@angular/common/http";
import {FileInfo, FileRestrictions} from "@progress/kendo-angular-upload";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-upload',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'upload.template.html',
  animations: [
    trigger('slideIn', [
      state('*', style({ 'overflow-y': 'hidden' })),
      state('void', style({ 'overflow-y': 'hidden' })),
      transition('* => void', [
        style({ height: '*' }),
        animate(250, style({ height: 0 }))
      ]),
      transition('void => *', [
        style({ height: '0' }),
        animate(250, style({ height: '*' }))
      ])
    ])
  ]
})
export class UploadAssetComponent {
  public uploadData: any;
  public assetRestrictions: FileRestrictions = {
    allowedExtensions: ['.pdf']
  };
  public assetUrl = 'https://s3-ca-central-1.amazonaws.com/orders.fitscanada.com/';
  public assets = [
    {title: 'Biomechanical Report', value: 'biomechanical'},
    {title: 'Lab Process Report', value: 'lab_process'},
  ];
  public asset: string;
  public selectedFiles: Array<FileInfo>;

  constructor(public dialogRef: MatDialogRef<UploadAssetComponent>,
              private builder: FormBuilder,
              private api: ApiService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  public assetChange($event): void {
    this.selectedFiles = [];
    this.api.get<any>(`/order/${this.data.id}/policy`, new HttpParams().set('asset', this.asset))
      .subscribe(credentials => {
        this.uploadData = {
          'key': credentials.key,
          'acl': 'private',
          'Content-Type': 'application/pdf',
          'X-Amz-Credential': credentials.credential,
          'X-Amz-Algorithm': credentials.algorithm,
          'X-Amz-Date': credentials.date,
          'Policy': credentials.policy,
          'X-Amz-Signature': credentials.signature
        };
      });
  }

  public uploadHandler($event): any {
    $event.data = this.uploadData;
  }

  public completeHandler($event): any {
    console.log('completed.');
    this.dialogRef.close();
  }

  public selectHandler($event): any {

  }

  public clearHandler($event): any {

  }

}
